/**
 * Generated by orval v7.10.0 🍺
 * Do not edit manually.
 * ZEP QUIZ
 * Zep Quiz API
 * OpenAPI spec version: 0.0.1
 */
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult,
} from '@tanstack/react-query';
import { useMutation, useQuery, useSuspenseQuery } from '@tanstack/react-query';

import type { BodyType, ErrorType } from '../../httpClient';
import { httpsInstance } from '../../httpClient';
import type {
  GetClassPointHistory1Params,
  GetClassPointHistoryParams,
  GetMyPointsParams,
  GrantPointReq,
  SseEmitter,
  SuccessBodyGrantPointRes,
  SuccessBodyPointHistoryRes,
} from '.././_model';

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

export const getClassPointHistory = (
  classGroupId: string,
  userId: string,
  params?: GetClassPointHistoryParams,
  options?: SecondParameter<typeof httpsInstance>,
  signal?: AbortSignal,
) => {
  return httpsInstance<SuccessBodyPointHistoryRes>(
    {
      url: `/classrooms/${classGroupId}/members/${userId}/points/grants`,
      method: 'GET',
      params,
      signal,
    },
    options,
  );
};

export const getGetClassPointHistoryQueryKey = (
  classGroupId: string,
  userId: string,
  params?: GetClassPointHistoryParams,
) => {
  return [
    `/classrooms/${classGroupId}/members/${userId}/points/grants`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetClassPointHistoryQueryOptions = <
  TData = Awaited<ReturnType<typeof getClassPointHistory>>,
  TError = ErrorType<unknown>,
>(
  classGroupId: string,
  userId: string,
  params?: GetClassPointHistoryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getClassPointHistory>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetClassPointHistoryQueryKey(classGroupId, userId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getClassPointHistory>>
  > = ({ signal }) =>
    getClassPointHistory(classGroupId, userId, params, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!(classGroupId && userId),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getClassPointHistory>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetClassPointHistoryQueryResult = NonNullable<
  Awaited<ReturnType<typeof getClassPointHistory>>
>;
export type GetClassPointHistoryQueryError = ErrorType<unknown>;

export function useGetClassPointHistory<
  TData = Awaited<ReturnType<typeof getClassPointHistory>>,
  TError = ErrorType<unknown>,
>(
  classGroupId: string,
  userId: string,
  params: undefined | GetClassPointHistoryParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getClassPointHistory>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getClassPointHistory>>,
          TError,
          Awaited<ReturnType<typeof getClassPointHistory>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetClassPointHistory<
  TData = Awaited<ReturnType<typeof getClassPointHistory>>,
  TError = ErrorType<unknown>,
>(
  classGroupId: string,
  userId: string,
  params?: GetClassPointHistoryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getClassPointHistory>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getClassPointHistory>>,
          TError,
          Awaited<ReturnType<typeof getClassPointHistory>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetClassPointHistory<
  TData = Awaited<ReturnType<typeof getClassPointHistory>>,
  TError = ErrorType<unknown>,
>(
  classGroupId: string,
  userId: string,
  params?: GetClassPointHistoryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getClassPointHistory>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetClassPointHistory<
  TData = Awaited<ReturnType<typeof getClassPointHistory>>,
  TError = ErrorType<unknown>,
>(
  classGroupId: string,
  userId: string,
  params?: GetClassPointHistoryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getClassPointHistory>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetClassPointHistoryQueryOptions(
    classGroupId,
    userId,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetClassPointHistorySuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getClassPointHistory>>,
  TError = ErrorType<unknown>,
>(
  classGroupId: string,
  userId: string,
  params?: GetClassPointHistoryParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getClassPointHistory>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetClassPointHistoryQueryKey(classGroupId, userId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getClassPointHistory>>
  > = ({ signal }) =>
    getClassPointHistory(classGroupId, userId, params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getClassPointHistory>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetClassPointHistorySuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getClassPointHistory>>
>;
export type GetClassPointHistorySuspenseQueryError = ErrorType<unknown>;

export function useGetClassPointHistorySuspense<
  TData = Awaited<ReturnType<typeof getClassPointHistory>>,
  TError = ErrorType<unknown>,
>(
  classGroupId: string,
  userId: string,
  params: undefined | GetClassPointHistoryParams,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getClassPointHistory>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetClassPointHistorySuspense<
  TData = Awaited<ReturnType<typeof getClassPointHistory>>,
  TError = ErrorType<unknown>,
>(
  classGroupId: string,
  userId: string,
  params?: GetClassPointHistoryParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getClassPointHistory>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetClassPointHistorySuspense<
  TData = Awaited<ReturnType<typeof getClassPointHistory>>,
  TError = ErrorType<unknown>,
>(
  classGroupId: string,
  userId: string,
  params?: GetClassPointHistoryParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getClassPointHistory>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};

export function useGetClassPointHistorySuspense<
  TData = Awaited<ReturnType<typeof getClassPointHistory>>,
  TError = ErrorType<unknown>,
>(
  classGroupId: string,
  userId: string,
  params?: GetClassPointHistoryParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getClassPointHistory>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
} {
  const queryOptions = getGetClassPointHistorySuspenseQueryOptions(
    classGroupId,
    userId,
    params,
    options,
  );

  const query = useSuspenseQuery(
    queryOptions,
    queryClient,
  ) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const grantPoints = (
  classGroupId: string,
  userId: string,
  grantPointReq: BodyType<GrantPointReq>,
  options?: SecondParameter<typeof httpsInstance>,
  signal?: AbortSignal,
) => {
  return httpsInstance<SuccessBodyGrantPointRes>(
    {
      url: `/classrooms/${classGroupId}/members/${userId}/points/grants`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: grantPointReq,
      signal,
    },
    options,
  );
};

export const getGrantPointsMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof grantPoints>>,
    TError,
    { classGroupId: string; userId: string; data: BodyType<GrantPointReq> },
    TContext
  >;
  request?: SecondParameter<typeof httpsInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof grantPoints>>,
  TError,
  { classGroupId: string; userId: string; data: BodyType<GrantPointReq> },
  TContext
> => {
  const mutationKey = ['grantPoints'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof grantPoints>>,
    { classGroupId: string; userId: string; data: BodyType<GrantPointReq> }
  > = props => {
    const { classGroupId, userId, data } = props ?? {};

    return grantPoints(classGroupId, userId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type GrantPointsMutationResult = NonNullable<
  Awaited<ReturnType<typeof grantPoints>>
>;
export type GrantPointsMutationBody = BodyType<GrantPointReq>;
export type GrantPointsMutationError = ErrorType<unknown>;

export const useGrantPoints = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof grantPoints>>,
      TError,
      { classGroupId: string; userId: string; data: BodyType<GrantPointReq> },
      TContext
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof grantPoints>>,
  TError,
  { classGroupId: string; userId: string; data: BodyType<GrantPointReq> },
  TContext
> => {
  const mutationOptions = getGrantPointsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const getMyPoints = (
  params?: GetMyPointsParams,
  options?: SecondParameter<typeof httpsInstance>,
  signal?: AbortSignal,
) => {
  return httpsInstance<SuccessBodyPointHistoryRes>(
    { url: `/points/me`, method: 'GET', params, signal },
    options,
  );
};

export const getGetMyPointsQueryKey = (params?: GetMyPointsParams) => {
  return [`/points/me`, ...(params ? [params] : [])] as const;
};

export const getGetMyPointsQueryOptions = <
  TData = Awaited<ReturnType<typeof getMyPoints>>,
  TError = ErrorType<unknown>,
>(
  params?: GetMyPointsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMyPoints>>, TError, TData>
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMyPointsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMyPoints>>> = ({
    signal,
  }) => getMyPoints(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMyPoints>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetMyPointsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMyPoints>>
>;
export type GetMyPointsQueryError = ErrorType<unknown>;

export function useGetMyPoints<
  TData = Awaited<ReturnType<typeof getMyPoints>>,
  TError = ErrorType<unknown>,
>(
  params: undefined | GetMyPointsParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMyPoints>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMyPoints>>,
          TError,
          Awaited<ReturnType<typeof getMyPoints>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetMyPoints<
  TData = Awaited<ReturnType<typeof getMyPoints>>,
  TError = ErrorType<unknown>,
>(
  params?: GetMyPointsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMyPoints>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMyPoints>>,
          TError,
          Awaited<ReturnType<typeof getMyPoints>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetMyPoints<
  TData = Awaited<ReturnType<typeof getMyPoints>>,
  TError = ErrorType<unknown>,
>(
  params?: GetMyPointsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMyPoints>>, TError, TData>
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetMyPoints<
  TData = Awaited<ReturnType<typeof getMyPoints>>,
  TError = ErrorType<unknown>,
>(
  params?: GetMyPointsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMyPoints>>, TError, TData>
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetMyPointsQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetMyPointsSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getMyPoints>>,
  TError = ErrorType<unknown>,
>(
  params?: GetMyPointsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMyPoints>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMyPointsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMyPoints>>> = ({
    signal,
  }) => getMyPoints(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getMyPoints>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetMyPointsSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMyPoints>>
>;
export type GetMyPointsSuspenseQueryError = ErrorType<unknown>;

export function useGetMyPointsSuspense<
  TData = Awaited<ReturnType<typeof getMyPoints>>,
  TError = ErrorType<unknown>,
>(
  params: undefined | GetMyPointsParams,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMyPoints>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetMyPointsSuspense<
  TData = Awaited<ReturnType<typeof getMyPoints>>,
  TError = ErrorType<unknown>,
>(
  params?: GetMyPointsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMyPoints>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetMyPointsSuspense<
  TData = Awaited<ReturnType<typeof getMyPoints>>,
  TError = ErrorType<unknown>,
>(
  params?: GetMyPointsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMyPoints>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};

export function useGetMyPointsSuspense<
  TData = Awaited<ReturnType<typeof getMyPoints>>,
  TError = ErrorType<unknown>,
>(
  params?: GetMyPointsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMyPoints>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
} {
  const queryOptions = getGetMyPointsSuspenseQueryOptions(params, options);

  const query = useSuspenseQuery(
    queryOptions,
    queryClient,
  ) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const subscribeMyPointEvents = (
  options?: SecondParameter<typeof httpsInstance>,
  signal?: AbortSignal,
) => {
  return httpsInstance<SseEmitter>(
    { url: `/points/events`, method: 'GET', signal },
    options,
  );
};

export const getSubscribeMyPointEventsQueryKey = () => {
  return [`/points/events`] as const;
};

export const getSubscribeMyPointEventsQueryOptions = <
  TData = Awaited<ReturnType<typeof subscribeMyPointEvents>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof subscribeMyPointEvents>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof httpsInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getSubscribeMyPointEventsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof subscribeMyPointEvents>>
  > = ({ signal }) => subscribeMyPointEvents(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof subscribeMyPointEvents>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type SubscribeMyPointEventsQueryResult = NonNullable<
  Awaited<ReturnType<typeof subscribeMyPointEvents>>
>;
export type SubscribeMyPointEventsQueryError = ErrorType<unknown>;

export function useSubscribeMyPointEvents<
  TData = Awaited<ReturnType<typeof subscribeMyPointEvents>>,
  TError = ErrorType<unknown>,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof subscribeMyPointEvents>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof subscribeMyPointEvents>>,
          TError,
          Awaited<ReturnType<typeof subscribeMyPointEvents>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useSubscribeMyPointEvents<
  TData = Awaited<ReturnType<typeof subscribeMyPointEvents>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof subscribeMyPointEvents>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof subscribeMyPointEvents>>,
          TError,
          Awaited<ReturnType<typeof subscribeMyPointEvents>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useSubscribeMyPointEvents<
  TData = Awaited<ReturnType<typeof subscribeMyPointEvents>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof subscribeMyPointEvents>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useSubscribeMyPointEvents<
  TData = Awaited<ReturnType<typeof subscribeMyPointEvents>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof subscribeMyPointEvents>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getSubscribeMyPointEventsQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getSubscribeMyPointEventsSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof subscribeMyPointEvents>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseSuspenseQueryOptions<
      Awaited<ReturnType<typeof subscribeMyPointEvents>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof httpsInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getSubscribeMyPointEventsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof subscribeMyPointEvents>>
  > = ({ signal }) => subscribeMyPointEvents(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof subscribeMyPointEvents>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type SubscribeMyPointEventsSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof subscribeMyPointEvents>>
>;
export type SubscribeMyPointEventsSuspenseQueryError = ErrorType<unknown>;

export function useSubscribeMyPointEventsSuspense<
  TData = Awaited<ReturnType<typeof subscribeMyPointEvents>>,
  TError = ErrorType<unknown>,
>(
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof subscribeMyPointEvents>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useSubscribeMyPointEventsSuspense<
  TData = Awaited<ReturnType<typeof subscribeMyPointEvents>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof subscribeMyPointEvents>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useSubscribeMyPointEventsSuspense<
  TData = Awaited<ReturnType<typeof subscribeMyPointEvents>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof subscribeMyPointEvents>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};

export function useSubscribeMyPointEventsSuspense<
  TData = Awaited<ReturnType<typeof subscribeMyPointEvents>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof subscribeMyPointEvents>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
} {
  const queryOptions = getSubscribeMyPointEventsSuspenseQueryOptions(options);

  const query = useSuspenseQuery(
    queryOptions,
    queryClient,
  ) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getClassPointHistory1 = (
  classGroupId: string,
  userId: string,
  params?: GetClassPointHistory1Params,
  options?: SecondParameter<typeof httpsInstance>,
  signal?: AbortSignal,
) => {
  return httpsInstance<SuccessBodyPointHistoryRes>(
    {
      url: `/classrooms/${classGroupId}/members/${userId}/points`,
      method: 'GET',
      params,
      signal,
    },
    options,
  );
};

export const getGetClassPointHistory1QueryKey = (
  classGroupId: string,
  userId: string,
  params?: GetClassPointHistory1Params,
) => {
  return [
    `/classrooms/${classGroupId}/members/${userId}/points`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetClassPointHistory1QueryOptions = <
  TData = Awaited<ReturnType<typeof getClassPointHistory1>>,
  TError = ErrorType<unknown>,
>(
  classGroupId: string,
  userId: string,
  params?: GetClassPointHistory1Params,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getClassPointHistory1>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetClassPointHistory1QueryKey(classGroupId, userId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getClassPointHistory1>>
  > = ({ signal }) =>
    getClassPointHistory1(classGroupId, userId, params, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!(classGroupId && userId),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getClassPointHistory1>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetClassPointHistory1QueryResult = NonNullable<
  Awaited<ReturnType<typeof getClassPointHistory1>>
>;
export type GetClassPointHistory1QueryError = ErrorType<unknown>;

export function useGetClassPointHistory1<
  TData = Awaited<ReturnType<typeof getClassPointHistory1>>,
  TError = ErrorType<unknown>,
>(
  classGroupId: string,
  userId: string,
  params: undefined | GetClassPointHistory1Params,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getClassPointHistory1>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getClassPointHistory1>>,
          TError,
          Awaited<ReturnType<typeof getClassPointHistory1>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetClassPointHistory1<
  TData = Awaited<ReturnType<typeof getClassPointHistory1>>,
  TError = ErrorType<unknown>,
>(
  classGroupId: string,
  userId: string,
  params?: GetClassPointHistory1Params,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getClassPointHistory1>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getClassPointHistory1>>,
          TError,
          Awaited<ReturnType<typeof getClassPointHistory1>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetClassPointHistory1<
  TData = Awaited<ReturnType<typeof getClassPointHistory1>>,
  TError = ErrorType<unknown>,
>(
  classGroupId: string,
  userId: string,
  params?: GetClassPointHistory1Params,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getClassPointHistory1>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetClassPointHistory1<
  TData = Awaited<ReturnType<typeof getClassPointHistory1>>,
  TError = ErrorType<unknown>,
>(
  classGroupId: string,
  userId: string,
  params?: GetClassPointHistory1Params,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getClassPointHistory1>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetClassPointHistory1QueryOptions(
    classGroupId,
    userId,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetClassPointHistory1SuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getClassPointHistory1>>,
  TError = ErrorType<unknown>,
>(
  classGroupId: string,
  userId: string,
  params?: GetClassPointHistory1Params,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getClassPointHistory1>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetClassPointHistory1QueryKey(classGroupId, userId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getClassPointHistory1>>
  > = ({ signal }) =>
    getClassPointHistory1(classGroupId, userId, params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getClassPointHistory1>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetClassPointHistory1SuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getClassPointHistory1>>
>;
export type GetClassPointHistory1SuspenseQueryError = ErrorType<unknown>;

export function useGetClassPointHistory1Suspense<
  TData = Awaited<ReturnType<typeof getClassPointHistory1>>,
  TError = ErrorType<unknown>,
>(
  classGroupId: string,
  userId: string,
  params: undefined | GetClassPointHistory1Params,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getClassPointHistory1>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetClassPointHistory1Suspense<
  TData = Awaited<ReturnType<typeof getClassPointHistory1>>,
  TError = ErrorType<unknown>,
>(
  classGroupId: string,
  userId: string,
  params?: GetClassPointHistory1Params,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getClassPointHistory1>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetClassPointHistory1Suspense<
  TData = Awaited<ReturnType<typeof getClassPointHistory1>>,
  TError = ErrorType<unknown>,
>(
  classGroupId: string,
  userId: string,
  params?: GetClassPointHistory1Params,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getClassPointHistory1>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};

export function useGetClassPointHistory1Suspense<
  TData = Awaited<ReturnType<typeof getClassPointHistory1>>,
  TError = ErrorType<unknown>,
>(
  classGroupId: string,
  userId: string,
  params?: GetClassPointHistory1Params,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getClassPointHistory1>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
} {
  const queryOptions = getGetClassPointHistory1SuspenseQueryOptions(
    classGroupId,
    userId,
    params,
    options,
  );

  const query = useSuspenseQuery(
    queryOptions,
    queryClient,
  ) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}
